import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link} from "react-router"
import _ from "lodash"
import {translate} from "translate"

import {Button, ButtonGroup, Card, Col, Form, FormField, FormInput, InputGroup, Row} from "elemental"
import shop from "../../shop/shop"
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs"
import swal from "sweetalert"
import app from "../../app.controller"
import theme from "../../theme"

import ProductTable from "../../components/Product/ProductTable"
import CartTotal from "../../components/Cart/CartTotal"
import Typeahead from "../../components/Typeahead/Typeahead"
import CustomProductOption from "../../components/CustomProductOption/CustomProductOption"

import CSV from "../../components/CSV/CSV"

import Price from "../../components/Price/Price"
import "./OrderlistPage.scss"

class OrderlistPage extends Component {
  constructor(props) {
    super( props )
    this.state = {
      lists: shop.orderlist.lists, id: props.params.id
    }
  }

  componentWillReceiveProps(props) {
    let { id } = props.params
    this.setState( {
      id
    } )
  }

  createList = (listname) => {
    console.log( `creating`, listname )
    let list = shop.orderlist.list( listname )
    list.save()
  }

  removeList = (listname) => {
    console.log( `removing`, listname )
    shop.orderlist.remove( listname )
  }

  componentDidMount() {
    let { orderlist } = shop
    window.orderlist  = orderlist
    // swal("Erfolg...", "Einstellungen gesichert", "success");
    // swal("Fehler...", "Something went wrong!", "error");
    // swal("Warnung...", "Something went wrong!", "warning");
    shop.orderlist.events.change.add( this.handleLists )
  }

  componentWillUnmount() {
    shop.orderlist.events.change.remove( this.handleLists )
  }

  handleLists = ({ lists }) => {
    this.setState( { lists } )
  }

  handleChange = ({ product }) => {
    let list = shop.orderlist.lists[ this.state.id ]
    list.add( product )
  }

  handleSelect = ({ product }) => {
    console.log( `selecting`, product )
    let list = shop.orderlist.lists[ this.state.id ]
    list.add( product )
  }

  render() {
    let path = [
      {
        title: translate( "orderlist.all_lists" ), link: "/orderlist"
      }
    ]
    if ( this.state.id ) {
      path.push( {
        title: this.state.id, link: `/orderlist/${this.state.id}`
      } )
    }
    let list = shop.orderlist.lists[ this.state.id ]

    return (
      <div className="container">
        <Breadcrumbs path={path}/>
        {/*LIST MANAGEMENT*/}
        {!this.state.id && <div>
          <h1>Merkliste</h1>
          <section>
            <Row>
              <Col sm="1/3">
                <CreateList handleCreate={this.createList}/>
              </Col>
            </Row>
          </section>
          <section>
            <ListsRow
              handleRemove={this.removeList}
              lists={shop.orderlist.lists}/>
          </section>
        </div>
        }

        {/*DETAILS FOR A SINGLE LIST*/}
        {this.state.id && <Row>
          <Col sm="1" md="3/4">
            <section>
              <div className="row-title title--left">
                <h2>{translate( "orderlist.add" )}</h2>
              </div>
              <Typeahead
                optionComponent={CustomProductOption}
                onSelect={this.handleSelect}
                value={this.state.value}
              />
            </section>
          </Col>
          {/*<Col sm="1" md="1/4">*/}
          {/*<div className="row-title title--left">*/}
          {/*<h2> Merkliste (.csv) hochladen </h2>*/}
          {/*</div>*/}
          {/*<CSV onResult={({products}) => {*/}
          {/*_.each(products, ( product => list.add(product)))*/}
          {/*}*/}
          {/*}/>*/}
          {/*<p>Hier können Sie ihre Bestellvorlage hochladen. Nutzen sie unsere <a*/}
          {/*download={`${theme.SHOPTITLE}-Bestellvorlage.csv`}*/}
          {/*href="/Bestellvorlage.csv">{`${theme.SHOPTITLE}-Bestellvorlage.csv`}</a>.</p>*/}
          {/*</Col>*/}
          <section className="padding-bottom db" style={{ width: "100%" }}>
            <Col sm="1">
              <div className="row-title title--left">
                <h2>{this.state.id}</h2>
              </div>
              <List list={list} onChange={this.handleChange}/>

              <div className="text-right pt3">
                <Button className=""
                        onClick={
                          () => {
                            shop.orderlist.lists[ this.state.id ] && shop.orderlist.lists[ this.state.id ].listToCart()
                            app.sidebar.toggle.dispatch()
                          }
                        }
                        type="primary"> <i className="icon-basket"/>{translate( "shop.add_all_products" )}</Button>
              </div>
            </Col>
          </section>

        </Row>
        }
      </div>
    )
  }
}

OrderlistPage.propTypes = {
  params: PropTypes.object.isRequired,
}

const CreateList     = ({ handleCreate }) => {
  let iRef
  return (
    <Form onSubmit={(e) => {
      handleCreate( iRef.refs.input.value )
      e.preventDefault()
    }}>
      <FormField label="Neuen Merkliste erstellen"
                 htmlFor="supported-controls-input">
        <InputGroup contiguous>
          <InputGroup.Section grow>
            <FormInput placeholder="Listenname"
                       id="newListName"
                       ref={(input) => {
                         iRef = input
                       }}
                       name="supported-controls-input"/>
          </InputGroup.Section>
          <InputGroup.Section>
            <Button submit
                    type="primary">{translate( "shop.create" )}</Button>
          </InputGroup.Section>
        </InputGroup>
      </FormField>
    </Form>
  )
}
CreateList.propTypes = {
  handleCreate: PropTypes.func
}

class ListCard extends Component {
  constructor(props) {
    super( props )
    console.log( `ListCard`, props )
    let { list } = props
    this.state   = {
      list
    }
    list.events.change.add( this.onChange )
  }

  onChange = ({ list }) => {
    console.log( `changed`, list )
    this.setState( list )
  }

  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.onChange )
  }

  render() {
    let { list, handleRemove } = this.props
    return (
      <Card>
        <Link to={`/orderlist/${list.title}`}>
          <h2>{list.title}</h2>
          <div>
            <strong><Price>{list.sum}</Price></strong> EUR <br />
            <strong>{list.size}</strong> {translate( "shop.article" )} <br />
          </div>
        </Link>
        <hr />
        <div className="text-right">
          <Button onClick={ () => swal( {
            title:             `${translate( "shop.delete" )}?`,
            text:              `${translate( "shop.list" )} "${list.title}"`,
            type:              "warning",
            showCancelButton:  true,
            animation:         false,
            confirmButtonText: "Ja, Liste löschen",
            cancelButtonText:  `${translate( "shop.back" )}`,
            closeOnConfirm:    true,
            html:              false
          }, () => {
            handleRemove( list.title )
          } )
          }>
            <i className="icon-cancel"/></Button>
          <Button onClick={() => {
            list.listToCart()
          }}
                  type="primary">
            <i className="icon-basket"/>
          </Button>
        </div>
      </Card>
    )
  }
}

ListCard.propTypes = {
  list: PropTypes.object, handleRemove: PropTypes.func
}

class List extends Component {
  constructor(props) {
    super( props )
    let { list } = props
    this.state   = {
      list
    }
    list.events.change.add( this.handleListChange )
  }

  handleListChange = () => {
    this.forceUpdate()
  }

  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.handleListChange )
  }

  render() {
    let { list, onChange } = this.props
    return <div className="cf">
      <ProductTable onChange={onChange} list={list}/>
      <CartTotal sum={list.sum} size={list.size}/>
      <br />
    </div>
  }
}

class ListRows extends Component {
  constructor(props) {
    super()
    let { list } = props
    this.state   = { list }
    list.events.change.add( this.onChange )
  }

  onChange = ({ list }) => {
    console.log( `changed`, list )
    this.setState( list )
  }

  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.onChange )
  }

  render() {
    let { list, onChange } = this.props
    let products           = _.map( list.products, (product, index) => {
      return (
        <Row key={index}>
          <Col sm="1/12">
            <img height="34"
                 src={product.img_src_small}
                 alt=""/></Col>
          <Col sm="1/12">{product.article_nr}</Col>
          <Col sm="1/12"><i className="icon icon-circle text-success"/></Col>
          <Col sm="4/12">{product.title}</Col>
          <Col sm="2/12"><Price>{product.price}</Price></Col>
          <Col sm="2/12"
               className="text-right">
            <InputGroup className="margin-0"
                        contiguous>
              <InputGroup.Section>
                <Button onClick={() => {
                  product.count--
                  onChange( { product } )
                }}>-</Button>
              </InputGroup.Section>
              <InputGroup.Section grow>
                <FormInput
                  tabIndex={index}
                  onChange={(e) => {
                    product.count = Number( e.target.value )
                    onChange( { product } )
                  }}
                  className="tc"
                  type="number"
                  value={product.count}
                  placeholder="0"/>
              </InputGroup.Section>
              <InputGroup.Section>
                <Button onClick={() => {
                  product.count++
                  onChange( { product } )
                }}>+</Button>
              </InputGroup.Section>
            </InputGroup>
            <ButtonGroup>
              <Button
                onClick={() => {
                  list.remove( product )
                }}
                className="btn-square"
                type="default"><i className="icon-cancel"/></Button>
              <Button
                onClick={() => {
                  list.toCart( product )
                }}
                className="btn-square"
                type="primary"><i className="icon-cart-plus"/></Button>
            </ButtonGroup>
          </Col>
        </Row>
      )
    } )
    return (
      <div className="orderlist-table">
        <Row className="text-bold header">
          <Col sm="1/12"/>
          <Col sm="1/12">{translate( "product.articlenr" )}</Col>
          <Col sm="1/12"><i className="icon icon-truck"/></Col>
          <Col sm="4/12">{translate( "product.description" )}</Col>
          <Col sm="2/12">{translate( "product.sum" )}</Col>
          <Col sm="2/12" className="text-right">{translate( "shop.actions" )}</Col>
        </Row>
        <div className="body">
          {products}
        </div>
      </div>
    )
  }
}

ListRows.propTypes = {
  list: PropTypes.object
}

const ListsRow     = ({ lists, handleRemove }) => {
  console.log( `list`, lists )
  let allLists = []
  _.forEach( lists, (list, index) => {
    allLists.push( (
      <Col
        xs="1/2"
        sm="1/3"
        md="1/3"
        lg="1/5"
        key={index}><ListCard handleRemove={handleRemove}
                              list={list}/></Col>
    ) )
  } )
  return <Row>
    {allLists}
  </Row>
}
ListsRow.propTypes = {
  lists: PropTypes.object, handleRemove: PropTypes.func
}

export default OrderlistPage



// WEBPACK FOOTER //
// ./src/pages/orderlist/OrderlistPage.js